import React from "react";
import i18n from "../../lib/i18n";
import Button from "../../components/GButton/Button";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";

export default function PackageCard({ pkg, openDeleteConfirmation, editLink }) {
  const t = i18n.t.bind(i18n);
  const nav = useNavigate();
  const currentLang = i18n.language;

  const handleNavigate = (nav) => {
    nav(nav);
  };

  return (
    <div className="bg-[#0E0E0E] text-white rounded-3xl shadow-lg border border-gray-700 p-6 flex flex-col justify-between w-full transition hover:shadow-2xl relative">

      {/* Header */}
      <div className="text-left mb-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">{pkg.title?.[currentLang]}</h2>
          <button onClick={() => openDeleteConfirmation(pkg.id)}><MdDelete className="text-xl text-red-600"/></button>
        </div>
        <p className="text-3xl font-extrabold text-secondary">
          US$ {pkg.price}
          <span className="text-base text-gray-400 font-normal">/{pkg.duration} {currentLang === "en" ? "Days" : "أيام"}</span>
        </p>
      </div>

      <div className="py-3 w-full text-center mb-2">
        <button className="bg-gray-500 py-2 rounded-md w-full" onClick={()=> nav(`${editLink}/${pkg.id}`)}>{currentLang === "en" ? "Edit Package" : "تعديل الباقة"}</button>
      </div>

      {/* Package Details */}
      <div className="text-[16px] space-y-2 mb-5">
        <p className="text-secondary">
          <strong>- {currentLang === "en" ? "Categories" : "الفئة"}:</strong>{" "}
          {pkg.sub_category_name}
        </p>
        <p>
          <strong>- {currentLang === "en" ? "Duration" : "مدة الإعلان"}:</strong>{" "}
          {pkg.duration} {currentLang === "en" ? "Days" : "أيام"}
        </p>
        <p>
          <strong>- {currentLang === "en" ? "No. photo" : "عدد الصور"}:</strong>{" "}
          {pkg.number_of_photo}
        </p>
        <p>
          <strong>- {currentLang === "en" ? "Position" : "الموضع"}:</strong>{" "}
          {pkg.position == 1 ? (currentLang == "en" ? "Normal Position" : "موضع عادي") : (currentLang == "en" ? "Home Page" : "موضع في الصفحة الرئيسية")}
        </p>
        <p>
          <strong>- {currentLang === "en" ? "Ad Shape" : "شكل الإعلان"}:</strong>{" "}
          {pkg.ad_shape == 1 ? (currentLang == "en" ? "Normal Shape" : "شكل عادي") : (currentLang == "en" ? "Vip Shape" : "شكل مميز")}
        </p>
        <p>
          <strong>- {currentLang === "en" ? "Top Result" : "نتائج أولية"}:</strong>{" "}
          {pkg.topResult == true ? (currentLang == "en" ? "Initial search results" : "ظهور أولي قي نتائج البحث") : (currentLang == "en" ? "Secondary appearance of search results" : "ظهور ثانوي قي نتائج البحث")}
        </p>
        <p className="text-gray-400 text-sm mt-2">
          {pkg.description?.[currentLang]}
        </p>
      </div>

      {/* Action Buttons */}
      <div className="flex justify-between gap-3 mt-auto">

      </div>
    </div>
  );
};

// import React from "react";
// import i18n from "../../lib/i18n";
// import Button from "../../components/GButton/Button";

// export default function PackageCard({ pkg, openDeleteConfirmation, editLink }) {
//   const t = i18n.t.bind(i18n);
//   const currentLang = i18n.language;

//   return (
//     <div className="bg-[#111111] rounded-2xl shadow-lg p-6 border border-gray-700 w-full max-w-sm mx-auto relative flex flex-col justify-between">
//       {/* Discount badge */}
//       {pkg.discount && (
//         <div className="absolute top-4 right-4 bg-[#E11D48] text-white text-xs font-semibold px-3 py-1 rounded-full">
//           {pkg.discount}% OFF
//         </div>
//       )}

//       {/* Title */}
//       <h2 className="text-lg font-semibold text-white mb-1">
//         {pkg.title?.[currentLang] || "KVM 1"}
//       </h2>

//       {/* Pricing */}
//       <div className="mb-4">
//         <p className="text-gray-400 text-sm line-through">
//           US$ {pkg.originalPrice || "13.99"}
//         </p>
//         <p className="text-white text-4xl font-bold">
//           US$ {pkg.price || "4.99"}
//           <span className="text-base text-gray-400 font-medium">/mo</span>
//         </p>
//       </div>

//       {/* Deal bar */}
//       <div className="bg-[#2D2B52] text-center text-sm text-purple-300 font-medium rounded-md py-1 mb-4">
//         {t("Limited time deal")}
//       </div>

//       {/* Renew info */}
//       <p className="text-gray-400 text-xs text-center mb-6">
//         Renews at US$ {pkg.renewPrice || "9.99"}/mo for 2 years. Cancel anytime.
//       </p>

//       {/* Package Specs */}
//       <div className="space-y-2 text-sm text-gray-200 mb-6">
//         <p>⚙️ {pkg.vcpu || "1 vCPU cores"}</p>
//         <p>🧠 {pkg.ram || "4 GB RAM"}</p>
//         <p>💾 {pkg.disk || "50 GB NVMe disk space"}</p>
//         <p>🌐 {pkg.bandwidth || "4 TB bandwidth"}</p>
//       </div>

//       {/* Buttons */}
//       <div className="flex justify-between gap-3">
//         <Button
//           text={t("button.edit")}
//           background="#2563EB"
//           color="white"
//           padding="10px 20px"
//           borderRadius="8px"
//           nav={`${editLink}/${pkg.id}`}
//         />
//         <Button
//           text={t("button.delete")}
//           background="#DC2626"
//           color="white"
//           padding="10px 20px"
//           borderRadius="8px"
//           onClick={() => openDeleteConfirmation(pkg.id)}
//         />
//       </div>
//     </div>
//   );
// }

